import { usd } from "./util";
import { pct } from "./graf";

export const Kpis = ({ kpis }) => {
  const cart = kpis?.total_cartera || 0;
  const items = [
    { id: "cartera", t: "Cartera total", v: kpis?.total_cartera, c: "#EEF3EC", p: cart ? 100 : 0, s: "saldo total abierto" },
    { id: "vencido", t: "Vencido", v: kpis?.valor_vencido, c: "#E07A62", p: pct(kpis?.valor_vencido || 0, cart), s: `${pct(kpis?.valor_vencido || 0, cart).toLocaleString("es-PY")}% de la cartera` },
    { id: "cobrado", t: "Cobrado del mes", v: kpis?.cobrado_mes, c: "#7DBE8C", p: pct(kpis?.cobrado_mes || 0, cart), s: `${pct(kpis?.cobrado_mes || 0, cart).toLocaleString("es-PY")}% de la cartera` },
  ];
  return (
    <div className="rs-cifras" data-testid="resumen-cifras">
      {items.map((k, i) => (
        <div className="rs-cifra rg-kpi" key={k.id} style={{ animationDelay: `${i * 110}ms` }} data-testid={`resumen-kpi-${k.id}`}>
          <small>{k.t}</small><b style={{ color: k.c }}>{usd(k.v)}</b>
          <i className="rg-barra"><u style={{ width: `${Math.min(100, k.p)}%`, background: k.c, animationDelay: `${300 + i * 110}ms` }} /></i>
          <em>{k.s}</em>
        </div>
      ))}
    </div>
  );
};
